enum IndicatorDefinition {
    SCC = "SCC",
    SC = "SC",
    SP = "SP",
    SHAB = "SHAB",
    SRO = "SRO",
    SVN = "SVN",
    SFB = "SFB",
    SHOB = "SHOB",
    SHO = "SHO",
    ST = "ST",
    SDP = "SDP",
    SUc = "SUc",
    SUbl = "SUbl",
    SUt = "Sut",
    SUb = "SUb",
    PARK = "PARK",
    SRV = "SRV",
    CTX = "CTX",
    SHOBh = "SHOBh",
    SCAsc = "SCAsc",
    SCEsc = "SCEsc",
    DedAsc = "DedAsc",
    DedEscPrv = "DedEscPrv",
    AjForfEsc = "AjForfEsc"
}

export default IndicatorDefinition;